// Components
import Page from '@/common-utils/components/structure/page/Page';
import RemoteCollectionsTable from '@/app/modules/remoteCollections/components/tables/RemoteCollectionsTable';
import RemoteCollectionsTotalRevenue from '@/app/modules/remoteCollections/components/common/RemoteCollectionsTotalRevenue';
// Common
import RouteUrls from '../enums/RouteUrls';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';

/**
 * @returns {JSX} RemoteCollections
 */
function RemoteCollections() {
    return (
        <Page>
            <Page.Header
                route={RouteUrls.REMOTE_COLLECTION}
                routeBase={RouteUrls.REMOTE_COLLECTION}
            />
            <Page.Body dataCy='page-remote-collections'>
                <RemoteCollectionsTable
                    filtersEventName={setFiltersEventName('remote_collections')}
                    pageActions={<RemoteCollectionsTotalRevenue />}
                />
            </Page.Body>
        </Page>
    );
}

export default RemoteCollections;